import { CarComparisonStore } from 'components/driving/store'
import { Menu } from './menu'

/**
 * Menu
 * The root element controlBtn button,
 * and this controls menu that the control button attribute determines
 * special case: when mobile search elements exist in the menu
 */
export class MenuDriving extends Menu {
    /**
     * call all the logic for opening the menu
     */
    protected openMenu(): void {
        super.openMenu()
        if (CarComparisonStore.getInstance().vehicleFinder) {
            CarComparisonStore.getInstance().vehicleFinder.close()
        }
    }
}
